import { render, staticRenderFns } from "./FS.vue?vue&type=template&id=0d0fa163&scoped=true&"
import script from "./FS.vue?vue&type=script&lang=ts&"
export * from "./FS.vue?vue&type=script&lang=ts&"
import style0 from "./FS.vue?vue&type=style&index=0&id=0d0fa163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0fa163",
  null
  
)

export default component.exports